import { useContext } from 'react';
import styled from 'styled-components';
import FindStoreItem from './findStoreItem';
import { FindStoreContext } from '../findStore';

const ListWrapper = styled.div``;

export default (): JSX.Element => {
    const { stores: parcelShops } = useContext(FindStoreContext);

    return (
        !!parcelShops?.length && (
            <ListWrapper>
                {parcelShops.map(
                    (parcelShop): JSX.Element => (
                        <FindStoreItem parcelShop={parcelShop} key={parcelShop.parcelShopId} />
                    )
                )}
            </ListWrapper>
        )
    );
};
